export default __webpack_public_path__ + "static/media/journaling-icon.decdbcda.svg";